import { render, staticRenderFns } from "./DesignScaleSettingTemplate.vue?vue&type=template&id=6fef8fee&scoped=true"
import script from "./DesignScaleSettingTemplate.vue?vue&type=script&lang=js"
export * from "./DesignScaleSettingTemplate.vue?vue&type=script&lang=js"
import style0 from "./DesignScaleSettingTemplate.vue?vue&type=style&index=0&id=6fef8fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fef8fee",
  null
  
)

export default component.exports